module.exports = __webpack_public_path__ + "static/media/Ar.0f203751.pdf";